import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'font-awesome/css/font-awesome.min.css';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

import PropTypes from 'prop-types';

const FloatingBar = ({ content, buttonText, handleButtonClick }) => {
  return (
    <div className="floating-menu-in align-items-center">
      <FontAwesomeIcon className="circle-question floating-bar-icon" icon={faCircleInfo} />
      <p className="floating-bar-text" dangerouslySetInnerHTML={{ __html: content }}></p>
      <div className="margin-left-auto">
        <button
          id="back_button"
          onClick={() => handleButtonClick()}
          className="btn btn-castleWhite btn-width">
          {buttonText}
        </button>
      </div>
    </div>
  );
};

FloatingBar.propTypes = {
  content: PropTypes.string,
  buttonText: PropTypes.string,
  handleButtonClick: PropTypes.func
};

export default FloatingBar;
